import { APP, ALIGN } from '_pixiSrc/globals';
import Sprite from '_pixiSrc/display/Sprite';
import I18 from '_pixiSrc/I18';
import ScreenLocker from './ScreenLocker';
import Button from './Button';
import Static from '../libraries/Static';

/**
* @class Paytable
* @classdesc Paytable class game information screen
*/
class Paytable extends Sprite {
    static invoke(x = 0, y = 0) {
        if (this.isOpen) {
            this.close();
            return;
        }

        this.container = new ScreenLocker(0X270029, 0.9);
        this.container.position.set(x, -242);

        this.isOpen = true;

        this.addButton(4);

        this.showTab(1);

        this.addKeyboardListeners();

        return this.container;
    }

    static addButton(total = 4) {
        this.buttonContainer = this.container.addChild(new Sprite());
        this.buttonContainer.position.set(0, 170);
        const btnState = {
            normal: 0,
            hover: 1,
            disable: 2,
            pressed: 3,
        };

        const exit = this.buttonContainer.addChild(new Button('paytable/popup-button', -12, 0, 0.85, () => {
            this.close();
        }, btnState));
        exit.hitArea = new PIXI.RoundedRectangle(-146, -27, 320, 54, 15);
        exit.exitText = Static.writeNativeText(exit, I18.f('returnText'), 'lato-regular', 15, 0, {
            fill: 0xfcd781,
            size: 22,
            align: ALIGN.CENTER,
            weight: 'bold',
        });

        this.buttonContainer.arrowLeft = this.buttonContainer.addChild(new Button('paytable/next', -175, 0, 0.55, btnState));
        this.buttonContainer.arrowLeft.scaleXTo(-0.55);
        this.buttonContainer.arrowLeft.hitArea = new PIXI.Circle(0, 0, 45);

        this.buttonContainer.arrowRight = this.buttonContainer.addChild(new Button('paytable/next', 175, 0, 0.55, btnState));
        this.buttonContainer.arrowRight.hitArea = new PIXI.Circle(0, 0, 45);
    }

    /**
   * @name showTab
   * @param tabNumber
   * @description show paytable tab
   */
    static showTab(tabNumber = 1) {
        if (this.container.tab) {
            this.container.tab.safeRemove();
        }

        // this.paginationButtons.forEach((button, index) => {
        //   if (index + 1 === tabNumber) {
        //     button.activeState.visible = true;
        //   } else {
        //     button.activeState.visible = false;
        //   }
        // });

        this.container.tab = this.container.addChild(APP.library.getSprite(`paytable/info-${tabNumber}`));
        this.container.tab.scale.set(0.8);
        this.container.tab.position.set(0, -60);

        this.buttonContainer.arrowLeft.clickAction = () => {
            let tab = tabNumber - 1;
            if (tabNumber === 1) {
                tab = 4;
            }
            this.showTab(tab);
        };
        this.buttonContainer.arrowRight.clickAction = () => {
            let tab = tabNumber + 1;
            if (tabNumber === 4) {
                tab = 1;
            }
            this.showTab(tab);
        };

        this.currentTabNumber = tabNumber;
    }

    /**
   * @name refresh
   * @description refresh current active tab
   */
    static refresh() {
        this.showTab(this.currentTabNumber);
    }

    /**
   * @name close
   * @description close paytable
   */
    static close() {
        if (this.isOpen) {
            document.documentElement.removeEventListener('keyup', this.escreference);
            this.escreference = null;
            this.container.safeRemove();
            this.container = null;
            this.buttonContainer = null;
            this.isOpen = false;
            if (this.callback) {
                this.callback();
            }
            this.callback = null;
        }
    }

    /**
   * passCloseCallback is used to give callback to paytable so it call it on close
   * @param  {Function} callback to call on close
   */
    static passCloseCallback(callback) {
        this.callback = callback;
    }

    static addKeyboardListeners() {
        this.escreference = this.escHandler.bind(this);
        document.documentElement.addEventListener('keyup', this.escreference);
    }

    static escHandler(event) {
        if (event.which !== 27) {
            return;
        }
        this.close();
        event.preventDefault();
    }
}

export default Paytable;
